/* KidCo theme scripts – no dependencies */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- mobile menu ---------- */
  var menuBtn = $('[data-menu-toggle]'), nav = $('[data-nav]');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open);
      menuBtn.textContent = open ? '✖️' : '🍔';
    });
  }

  /* ---------- search drawer ---------- */
  var searchBtn = $('[data-search-toggle]'), drawer = $('[data-search]');
  if (searchBtn && drawer) {
    searchBtn.addEventListener('click', function () {
      drawer.hidden = !drawer.hidden;
      if (!drawer.hidden) { var i = $('input[type=search]', drawer); if (i) i.focus(); }
    });
  }

  /* ---------- collection filters ---------- */
  var fToggle = $('[data-filters-toggle]'), fPanel = $('[data-filters-panel]');
  if (fToggle && fPanel) {
    var anyActive = $$('input:checked', fPanel).length > 0;
    fPanel.hidden = !anyActive;
    fToggle.addEventListener('click', function () { fPanel.hidden = !fPanel.hidden; });
  }
  $$('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* ---------- quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = $('[data-qty]', (minus || plus).parentNode);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var val = parseInt(input.value || '1', 10) + (plus ? 1 : -1);
    input.value = Math.max(min, val);
  });

  /* ---------- money formatting ---------- */
  function formatMoney(cents) {
    var fmt = window.KidCoMoney || '${{amount}}';
    var n = (cents / 100);
    function fix(num, dec, thou, decSep) {
      var s = num.toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return s.join(dec ? decSep : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, t) {
      switch (t) {
        case 'amount_no_decimals': return fix(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(n, 2, "'", '.');
        default: return fix(n, 2, ',', '.');
      }
    });
  }

  /* ---------- product page: variants + gallery ---------- */
  var product = $('[data-product]');
  if (product) {
    var jsonEl = $('[data-variants-json]', product), variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) {}
    var img = $('[data-gallery-img]', product);
    var thumbs = $$('.thumb', product);

    function showImage(src, id) {
      if (img && src) img.src = src;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', id && String(t.dataset.imageId) === String(id)); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showImage(t.dataset.full, t.dataset.imageId); });
    });

    var optionSets = $$('[data-option]', product);
    function currentVariant() {
      var chosen = optionSets.map(function (set) {
        var c = $('input:checked', set); return c ? c.value : null;
      });
      return variants.filter(function (v) {
        return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }
    function update() {
      var v = currentVariant();
      var btn = $('[data-add-btn]', product), idInput = $('[data-variant-id]', product);
      var priceWrap = $('[data-price-wrap]', product);
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Not available 🙈'; } return; }
      if (idInput) idInput.value = v.id;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart 🛒' : 'Sold out 😢'; }
      if (priceWrap) {
        var html = '<div class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '"><span class="price__now">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price > v.price) html += '<s class="price__was">' + formatMoney(v.compare_at_price) + '</s>';
        priceWrap.innerHTML = html + '</div>';
      }
      if (v.featured_image) {
        var src = v.featured_image.src;
        var match = thumbs.filter(function (t) { return String(t.dataset.imageId) === String(v.featured_image.id); })[0];
        showImage(match ? match.dataset.full : src, v.featured_image.id);
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    optionSets.forEach(function (set) { set.addEventListener('change', update); });
  }

  /* ---------- account page helpers ---------- */
  var recoverLink = $('[data-recover-toggle]'), recover = $('#recover');
  if (recoverLink && recover) {
    recoverLink.addEventListener('click', function (e) { e.preventDefault(); recover.hidden = !recover.hidden; });
    if (window.location.hash === '#recover') recover.hidden = false;
  }
  $$('select[data-default]').forEach(function (sel) {
    var d = sel.getAttribute('data-default');
    if (d) for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === d || sel.options[i].text === d) sel.selectedIndex = i;
  });
  $$('form[data-confirm]').forEach(function (f) {
    f.addEventListener('submit', function (e) { if (!window.confirm('Delete this address?')) e.preventDefault(); });
  });
})();
